<template>
  <!-- TODO: 205 Video don't stop if change slide -->
  <video-player
    v-if="videoSrc"
    :src="videoSrc"
    :poster="poster"
    controls
    :loop="false"
    :volume="0.6"
    ref="player"
  >
    <template v-slot>
      <div class="custom-player-controls" v-if="videoSrc && title">
        <a v-if="videoSrc && title" @click.prevent="downloadItem(videoSrc, title)" class="video-control-download-control">
          <svg class="icon-download">
            <use href="/sprite.svg#download"></use>
          </svg>
        </a>
      </div>
    </template>
  </video-player>
</template>

<script setup lang="ts">
import axios from 'axios';
import { VideoPlayer } from '@videojs-player/vue';
import 'video.js/dist/video-js.css';

const props = defineProps({
  videoSrc: String,
  poster: { type: String, default: '' },
  title: String
});

const downloadItem = (url: string, label: string) => {
  axios.get(url, { responseType: 'blob' })
    .then((response) => {
      const blob = new Blob([response.data], { type: 'video/mp4' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    }).catch(console.error);
};
</script>
